import { Toast } from "@vitalsource/vstui";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import useMosaicEvent from "../connectors/events/useMosaicEvent";
import ViewerEvent from "../api/core/ViewerEvent";

export default function ErrorToast() {
  const [isShowing, setIsShowing] = useState(false);
  const intl = useIntl();

  const closeToast = useCallback(() => {
    setIsShowing(false);
  }, []);

  const openToast = useCallback(() => {
    setIsShowing(true);
  }, []);

  useMosaicEvent(ViewerEvent.SNIPPET_NAV_BLOCKED, openToast);

  return (
    <Toast
      open={isShowing}
      toastClose={closeToast}
      toastTitleText={intl.formatMessage({ id: "errors.navigationDisabled" })}
      toastType="error"
    />
  );
}
